import { useEffect, useState } from 'react';

/** The value once it has stopped changing for `ms`, so BrickLink is asked about a part number and not every keystroke. */
export function useSettled<T>(value: T, ms = 400): T {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return settled;
}
